import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {ActiveQuotesService} from "../../services/active-quotes.service";
import {NewQuoteRequest} from "./new-quote-request.model";
import {ActivatedRoute, Router} from "@angular/router";
import {OktaAuthService} from "@okta/okta-angular";
import {UtilService} from "../../services/util.service"
import {RequestUtility} from "./new-quote-request.model"
import {DataService} from "../../services/data.service";
import {MatStepper} from "@angular/material/stepper";
import {Observable} from "rxjs";


@Component({
  selector: 'app-new-quote-request',
  templateUrl: './new-quote-request.component.html',
  styleUrls: ['./new-quote-request.component.scss']
})
export class NewQuoteRequestComponent implements OnInit {

  isLoading: boolean = false;
  requestFormData: any[];
  requestForm: FormGroup;
  market: string;
  brokerEmail: string;
  brokerName: string;
  salesPerson: string;
  minDate: Date;
  utilityLovs: any;
  createNewForm: boolean = false;
  fileLoading: boolean = false;
  productPassThroughFlags: any = {
    // "productEnergyPassthrough": 0,
    // "productCapacityPassthrough": 0,
    // "productTransmissionPassthrough": 0,
    // "productBasisPassthrough": 0,
    // "productLossesPassthrough": 0,
    // "productAsPassthrough": 0,
    // "productRpsPassthrough": 0,
    // "productBasicPassthrough": 0,
    // "productPrsPassthrough": 0,
    // "productArrPassthrough": 0,
    // "productCrrPassthrough": 0,
    // "productUpliftPassthrough": 0,
    // "productMlcPassthrough": 0,
    // "energy": 0,
    "capacity": 0,
    "transmission": 0,
    "basis": 0,
    "losses": 0,
    "ancillaryServices": 0,
    "renewables": 0,
    "arr": 0,
    "mlc": 0,
    "crr": 0,
    "uplift": 0
  };
  stateOptions: any[] = [];
  accountValidRecord: any = {};
  @ViewChild("stepper") stepper: MatStepper;

  constructor(private httpService: HttpClient, public form: FormBuilder, private quoteService: ActiveQuotesService, private route: ActivatedRoute, private oktaAuth: OktaAuthService, private utilService: UtilService, private service: DataService, private router: Router) {
    this.minDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000 * 4);
  }


  async ngOnInit(): Promise<void> {
    this.route.params.subscribe(params => this.market = params['id']);
    await this.oktaAuth.getUser().then(data => {
      this.brokerEmail = data.email;
      this.brokerName = data.company;
      this.salesPerson = data.salesPerson;
    })
    // this.isLoading = true;
    this.getStateOptions();
    await this.httpService.get('./assets/newRequestQuoteMetadata.json').toPromise().then((res: any) => {
      this.requestForm = this.form.group(this.createFormModel(res.formMetaData));
      this.requestFormData = res.formMetaData;
      this.utilityLovs = res.utilityLovs;
      console.log(this.requestForm.value);
    })

  }

  createFormModel(metadata: any[], data?: object){
    let form = {};
    metadata.forEach(item => {
      if(item.type == 'array'){
        form[item.field] = this.form.array(item.field != 'requestFacility' ? [this.form.group(this.createFormModel(item.items))]: [])
      }else if(item.type == 'object'){
        form[item.field] = this.form.group(this.createFormModel(item.items));
      }else {
        if(item.type != 'button') {
          form[item.field] = [this.setDefaultValue(item, data), item.required ? [Validators.required] : []];
          // if(item.field === 'accountNumber') {
          //   form[item.field][1].push(this.accountValidator.bind(this));
          // }
        }
      }

    })
    return form;
  }

  setDefaultValue({field, required, defaultValue, multiple, type}, data?: object){
    switch (field){
      case "market": return this.market || '';
      case "brokerName": return this.brokerName || '';
      case "brokerEmailAddress": return this.brokerEmail || '';
      case "salesPerson": return this.salesPerson || '';
      default: return  data ? data[field]: defaultValue || (multiple ? []: type ? '': null);
    }
  }

  get accountNumberCtrl() {
    let utilities = this.requestUtilities;
    return utilities.get('accountNumber');
  }


  get requestUtilities(){
    return this.requestForm.get("requestUtility") as FormArray;
  }
  get requestFacilities(){
    return this.requestForm.get("requestFacility") as FormArray;
  }
  get requestProducts(){
    return this.requestForm.get("requestProduct") as FormGroup;
  }
  async addAccount(item) {
    let utilities = this.requestUtilities;
    if(!utilities.valid){
      this.utilService.errorMessage("Please fill all utility fields");
      return;
    }
    let obj = JSON.parse(JSON.stringify(utilities.value[0])) as RequestUtility;
    obj.accountNumber = obj.accountNumber.trim();
    let accountNumbers;
    if(obj.accountNumber.indexOf('\n') >= 0){
      accountNumbers = obj.accountNumber.split('\n')
    }else if(obj.accountNumber.indexOf(',') >= 0){
      accountNumbers = obj.accountNumber.split(',')
    }else if(obj.accountNumber.indexOf(' ') >= 0){
      accountNumbers = obj.accountNumber.split(' ')
    }else{
      accountNumbers = [obj.accountNumber];
    }
    if(accountNumbers && accountNumbers.length){
      accountNumbers = this.checkDuplicateAccountNumbers(accountNumbers);
      this.isLoading = true;
      this.accountValidRecord.errorNumbers = null;
      this.accountValidRecord.error = ""
      for(let accNum of accountNumbers){
        await this.service.getApiData(`quickquotes/validation/${obj.utilityName}/${accNum}`, 'GET').toPromise().then((res: any) => {
          if(res.validateSuccess && !this.accountValidRecord.error){

          }
          // else{
          //   this.accountValidRecord.error = res.errorMessage;
          // }
        }).catch(err => {
          const {error, message} = err;
          this.accountValidRecord.error = error && error.errorMessage || message || 'Failed to validate account numbers';
          if(this.accountValidRecord.errorNumbers)
            this.accountValidRecord.errorNumbers.push(accNum)
          else
            this.accountValidRecord.errorNumbers = [accNum]
        })
        // if(this.accountValidRecord.error){
        //   break;
        // }
      }
      this.isLoading = false;
      if(!this.accountValidRecord.error) {
        this.accountValidRecord = {}
        accountNumbers.forEach(item => {
          obj.facilityNumber = item;
          // let serviceAddressState = this.utilityLovs[obj.market][obj.utilityName];
          this.requestFacilities.push(
            this.form.group(
              this.createFormModel(this.getMetaItem('requestFacility').items, {...obj, ...{'serviceAddressState': obj.state}})
            )
          );
        })
        // utilities.controls[0].reset({market: utilities.value[0].market});
        utilities.controls[0].reset({state: utilities.value[0].state});
        this.accountValidRecord = {};
      }
    }
    // this.requestFacilities.push(
    //   this.form.group(
    //     this.createFormModel(this.getMetaItem('requestFacility').items)
    //   )
    // );
  }

  checkDuplicateAccountNumbers(newAcNumbers){
    let acNumbers = this.requestFacilities.value.map(item => item.accountNumber);
    let duplicateNums = [];
    acNumbers.forEach(item => {
      if(newAcNumbers.includes(item)){
        newAcNumbers.splice(newAcNumbers.indexOf(item), 1);
        duplicateNums.push(item);
      }
    })
    if(duplicateNums.length)
      this.utilService.errorMessage(`Duplicate account numbers found: [${duplicateNums.join(',')}]`);
    return newAcNumbers;
  }

  removeFacility(ind){
    this.requestFacilities.removeAt(ind);
  }

  addProduct(){
    let products = this.requestProducts.get('products') as FormArray;
    products.push(
      this.form.group(
        this.createFormModel(this.getMetaItem('requestProduct').items[0].items)
      )
    )
  }
  removeProduct(ind){
    let products = this.requestProducts.get('products') as FormArray;
    products.removeAt(ind);
  }

  getMetaItem(field){
    let filterItem = this.requestFormData.filter(item => item.field == field);
    return filterItem[0];
  }


  async submitRequest(){
    // let attachments = this.requestForm.get('attachments').value;
    let payload: any = JSON.parse(JSON.stringify(this.requestForm.value));
    let requestUtility = payload.requestUtility[0];
    payload.lstCustomDealRequestFacility = payload.requestFacility;
    payload.market = this.market;
    // payload.state = requestUtility.state;
    payload = {...payload, ...payload.requestProduct};
    delete payload.requestProduct;
    delete payload.requestFacility;
    delete payload.requestUtility;
    // console.log(payload);
    if(payload.products && payload.products.length) {
      payload.lstCustomDealRequestProductRfp = payload.products.map(item => {
        let passThroughFlags = JSON.parse(JSON.stringify(this.productPassThroughFlags));
        if (item.passThrough.length) {
          item.passThrough.forEach(innerItem => {
            Object.keys(passThroughFlags).forEach(flag => {
              if (flag.toLowerCase().indexOf(innerItem.toLowerCase()) >= 0) {
                // passThroughFlags[flag] = 1;
                passThroughFlags[innerItem] = 1;
              }
            })
          })
        }
        delete item.passThrough;
        item = {...item, ...passThroughFlags};
        return item;
      })
      delete payload.products;
      // delete payload.swing;
    }
    // if(payload.attachments && payload.attachments.length) {
    //   payload.attachments = payload.attachments.map(item => {
    //     return {name: item.name, size: item.size};
    //   })
    // }
    // console.log(payload);
    delete payload.attachments;
    this.isLoading = true;
    await this.service.makeCustomDealRequest(payload).toPromise().then(res=>{
      // if(res) {
        this.utilService.successMessage("Request Submitted Successfully");
        if(!this.createNewForm) {
          setTimeout(() => {
            this.router.navigate(['/rfp-history']);
          }, 1000)
        }
      // }else{
      //   this.utilService.errorMessage('Unfortunately there is a system issue please try again later');
      // }
    }).catch(err => {
      if(err.status == 500)
        this.utilService.errorMessage('Unfortunately there is a system issue please try again later');
      else
        this.utilService.errorMessage(err.message || "Failed to submit the request");
    }).finally(()=>{
      this.isLoading = false;
    })
    if(this.createNewForm) {
      this.requestForm = this.form.group(this.createFormModel(this.requestFormData));
      this.createNewForm = !this.createNewForm;
      this.stepper.reset();
    }
  }

  disableScreenOneBtn(){
    if(this.requestForm) {
      let requestForm = this.requestForm.value;
      return requestForm.legalEntityName && requestForm.billingAddressLin1 && requestForm.dueDate;
    }
    return false;
  }

  selectItem(option, cItem, pItem, pIndex?, parentItem?){
    let opt = option && option.id ? option.id: option;
    let requestForm;
    if(parentItem){
      requestForm = this.requestForm.get(parentItem.field) as FormGroup
      if(pItem.type == 'array'){
        requestForm = requestForm.get(pItem.field) as FormArray;
        requestForm = requestForm.controls[pIndex] as FormGroup;
      }
    }else{
      requestForm = this.requestForm.get(pItem.field) as FormGroup;
    }
    // let model = this.requestForm.get(pField) as FormGroup;
    let currentValue;
    if(cItem.multiple){
    currentValue = requestForm.get(cItem.field).value;
      if(currentValue.includes(opt))
        currentValue.splice(currentValue.indexOf(opt),1);
      else
        currentValue.push(opt);
    }
    requestForm.get(cItem.field).setValue(currentValue || opt);
  }

  // makeFacilities(facilities: FacilityDetails[]){
  //   this.quoteMeterList = new MatTableDataSource(facilities as FacilityDetails[]);
  //   // this.quoteMeterList.paginator = this.paginator;
  //   this.quoteMeterList.sort = this.sort;
  // }

  // accountValidator(control: AbstractControl){
  //   let pattern = this.accountValidRecord.regex;
  //   return null;
  // }

  getOptions(obj: any){
    let requestForm = this.requestForm.value;
    let dependentValue = this.utilService.jsonPath(obj.path, requestForm);
    if(obj.path && obj.path.indexOf('state') !== -1){
      if(this.stateOptions.length){
        for(let item of this.stateOptions){
          if(item.utilityState === dependentValue) {
            this.market = dependentValue = item.utilityMarket;
            break;
          }
        }
      }
    }
    return obj['options'][dependentValue] || [];
  }

  getValue(field: any, item?: any, formInd?: number, parentItem?: any) {
    // jsonPath.value()
    let requestForm;
    if(parentItem){
      requestForm = this.requestForm.get(parentItem.field) as FormGroup
    }else{
      requestForm = this.requestForm;
    }
    if(item && item.type == 'array' ){
      return requestForm.get(item.field).value[formInd][field];
    }else if(item && item.type == 'object'){
      return requestForm.get(item.field).value[field];
    }else{
      return this.requestForm.get(field).value
    }
  }

  async getStateOptions(){
      await this.service.getApiData('get-utilities/statenamemarket', 'GET').toPromise().then((res: any[]) => {
        this.stateOptions = res as any[];
      }).finally(() => {

      });

  }

  // async asyncOptionSelected(e, field: string){
  //   if(field === "utilityName" && e && e.option.value){
  //     this.isLoading = true;
  //     await this.service.getApiData(`quickquotes/validationrecord/${e.option.value}`, 'GET').toPromise().then(res => {
  //       this.accountValidRecord = res;
  //     }).catch(err => {
  //       this.accountValidRecord = {};
  //       this.utilService.errorMessage(err.message || 'Failed to validate');
  //     })
  //     this.isLoading = false;
  //   }
  // }

  onFileDropped($event, field){
    this.requestForm.get(field).setValue($event);
  }

  uploadAttachments(){
    let attachments = this.requestForm.get('attachments').value;
    attachments = this.utilService.convertToUploadFileFormat(attachments);
    this.fileLoading = true;
    this.service.uploadAttachments(attachments).subscribe((res: HttpResponse<any>) => {
      this.utilService.successMessage(typeof res == 'string' && res || 'Files Uploaded Successfully');
      this.fileLoading = false;
    }, (err: HttpErrorResponse) => {
      if(err.status == 200)
       this.utilService.successMessage(err.error && err.error.text || err.message || typeof err == 'string' && err || 'Upload Successfully');
      else
        this.utilService.errorMessage(err.error && err.error.text || err.message || typeof err == 'string' && err || 'Uploaded failed please try again');
      this.fileLoading = false;
    }
    )
  }

}
